"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @mg/shared — types/enums contract shared by the NestJS API and the React SPA.
 */
__exportStar(require("./billing"), exports);
__exportStar(require("./enums"), exports);
__exportStar(require("./common"), exports);
__exportStar(require("./tenant"), exports);
__exportStar(require("./brand-template"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./source"), exports);
__exportStar(require("./trend-topic"), exports);
__exportStar(require("./brief"), exports);
__exportStar(require("./content"), exports);
__exportStar(require("./design-bundle"), exports);
__exportStar(require("./design-generation"), exports);
__exportStar(require("./prompt-from-post"), exports);
__exportStar(require("./design-ir"), exports);
__exportStar(require("./design-composition"), exports);
__exportStar(require("./design-edits"), exports);
__exportStar(require("./design-tools"), exports);
__exportStar(require("./media-models"), exports);
__exportStar(require("./calendar"), exports);
__exportStar(require("./scheduling"), exports);
__exportStar(require("./approval"), exports);
__exportStar(require("./brand-voice"), exports);
__exportStar(require("./asset"), exports);
__exportStar(require("./chat"), exports);
__exportStar(require("./chatAnswers"), exports);
__exportStar(require("./social"), exports);
__exportStar(require("./social-app-keys"), exports);
__exportStar(require("./char-count"), exports);
__exportStar(require("./analytics"), exports);
__exportStar(require("./entra-groups"), exports);
__exportStar(require("./platform-settings"), exports);
__exportStar(require("./ai-models"), exports);
__exportStar(require("./audit"), exports);
__exportStar(require("./brand-fields"), exports);
__exportStar(require("./brand-profile"), exports);
__exportStar(require("./brand-import"), exports);
__exportStar(require("./brand-suggestions"), exports);
__exportStar(require("./website-url"), exports);
//# sourceMappingURL=index.js.map